import RequestBase from "./RequestBase.ts";

export default class ServerRequests extends RequestBase {
    constructor(){
        super("Servers/");
    }

    GetAllServers = (SetServerData) => {
        this.defaultAxios.get("GetServers")
        .then((res) => 
        {
            SetServerData(res.data);
        })
    };

    GetStaffChat = (serverId, onSucess) => {
        this.defaultAxios.get(`GetStaffChat/${serverId}`)
        .then((res) => 
        {
            onSucess(res.data);
        })
    };

    ExecuteCommand = (serverId, command, onSuccess) => {
        this.defaultAxios.post(`ExecuteCommand/${serverId}`, command)
        .then((res) => 
        {
            onSuccess(res.data);
        })
    }


    SearchServerLogs = (filter, onSuccess) => {
        this.defaultAxios.post(`SearchServerLogs/`, filter)
        .then((res) => 
        {
            onSuccess(res.data);
        })
    }

    GetPunishmentsData = (serverId, onSuccess) => {
        this.defaultAxios.get(`GetPunishmentsData/${serverId}`)
        .then((res) => 
        {
            onSuccess(res.data.data);
        })
    }

    EditPunishment = (data, onSuccess) => {
        this.defaultAxios.post(`EditPunishment`, data)
        .then((res) => 
        {
            onSuccess(res.data.data);
        })
    }
    
    RemovePunishment = (data, onSuccess) => {
        this.defaultAxios.post(`RemovePunishment`, data)
        .then((res) => 
        {
            onSuccess(res.data.data);
        })
    }
}